@if (!rmcUpload && !mobileUser && !isMedicalAppeals) {
<div>
  <section>
    @if (!isChangeMode && !isPresumptive && !isFinReassessment &&
    !isAdmitDischarge && !isNewborn && !isAppeals && !isBCCEXT && !isIME &&
    !isPreterm) {
    <h1 class="page-title">
      @if (!isPreterm) {
      <span
        >{{ CONGRATS_STATIC_TEXT | globalTranslate }}
        {{ appKeyWord | globalTranslate }}!</span
      >
      }
    </h1>
    } @if (!isChangeMode && !isPresumptive && !isFinReassessment &&
    !isAdmitDischarge && !isNewborn && !isAppeals && !isBCCEXT && !isIME &&
    isPreterm) {
    <h1 class="page-title">
      @if (isPreterm) {
      <span
        >{{ CONGRATS_STATIC_TEXT_QFR5 | globalTranslate }}
        {{ appKeyWord | globalTranslate }}!</span
      >
      }
    </h1>
    } @if (isAdmitDischarge) {
    <h1 class="m-3 admit-discharge-title-head">Success!</h1>
    } @if (isAdmitDischarge) {
    <h2 class="m-3 admit-discharge-title-subhead">
      Your 2350 Form has been sent to TennCare!
    </h2>
    } @if (isNewborn) {
    <h1 class="m-3 page-title">
      Success! Your Newborn Form has been sent to TennCare!
    </h1>
    } @if (isChangeMode && !isPresumptive) {
    <h1 class="page-title">{{ CONGRATS_STATIC_TEXT0 | globalTranslate }}</h1>
    } @if (isPresumptive) {
    <h1 class="m-3 page-title">
      Success! This application has been sent to TennCare!
    </h1>
    } @if (isFinReassessment) {
    <h1 class="m-3 page-title">
      Success! This Financial Application has been sent to TennCare!
    </h1>
    } @if (isBCCEXT) {
    <h1 class="m-3 page-title">We have your BCC Extension Request Form!</h1>
    } @if (isIME) {
    <h1 class="m-3 page-title">
      Success!<br />Your Incurred Medical Expense Form has been sent to
      TennCare!
    </h1>
    }
  </section>
  @if (!isPresumptive && !isAdmitDischarge && !isNewborn && !isFinReassessment
  && !isAppeals && !isBCCEXT && !isIME) {
  <section class="border bg-white p-3">
    <section class="p-2">
      <div class="row">
        <div class="col">
          @if (!isPreterm) {
          <p class="static-text">
            {{ CONGRATS_STATIC_TEXT1 | globalTranslate }}
            {{ appKeyWord_1 | globalTranslate }}
            {{ CONGRATS_STATIC_TEXT2 | globalTranslate }}
            <strong>{{ workerPortalAppNum }}</strong
            >.
          </p>
          } @if (isPreterm) {
          <p class="static-text">
            {{ CONGRATS_STATIC_TEXT_QFR6 | globalTranslate }}
            {{ appKeyWord | globalTranslate }}
            {{ CONGRATS_STATIC_TEXT_QFR7 | globalTranslate }}
            <strong>{{ workerPortalAppNum }}</strong
            >.
          </p>
          }
          <p class="static-text">
            {{ CONGRATS_STATIC_TEXT3 | globalTranslate }}
          </p>
          @if (!isChangeMode && !isPreterm && !isRedeModeOnly) {
          <p class="static-text">
            {{ CONGRATS_STATIC_TEXT4 | globalTranslate }}
            <strong>{{
              appSubmittedDate | date: "longDate" | globalTranslate
            }}</strong
            >.
          </p>
          } @if (!isChangeMode && !isPreterm && isRedeModeOnly) {
          <p class="static-text">
            {{ CONGRATS_STATIC_TEXT4_1 | globalTranslate }}
            <strong>{{
              appSubmittedDate | date: "longDate" | globalTranslate
            }}</strong
            >.
          </p>
          } @if (!isChangeMode && isPreterm) {
          <p class="static-text">
            {{ CONGRATS_STATIC_TEXT4_QFR | globalTranslate }}
            <strong>{{
              appSubmittedDate | date: "longDate" | globalTranslate
            }}</strong
            >.
          </p>
          } @if (isChangeMode) {
          <p class="static-text">
            {{ CONGRATS_CHAGE_MODE | globalTranslate }}
            <strong>{{ appSubmittedDate | date: "MM/dd/yyyy" }}</strong
            >.
          </p>
          }
        </div>
      </div>
    </section>
    <div class="p-2">
      @if (this.isFullMedicAidApp) {
      <div>
        <h1 class="section-header">Confirmation of Your Submission</h1>
        <hr />
        <div class="static-text">
          <p>
            You can save this as a confirmation of your submission by clicking
            the <b>Print</b> button at the bottom of this screen. You can also
            access this information at any time via the
            <a
              href="/api/prov/submission-search"
              title="Search My Submissions"
              aria-label="Search My Submissions"
              >Search My Submissions
            </a>
            page.
          </p>
          <p>
            You can print this page and give it to the applicant to keep. It has
            important information that may help them later.
          </p>
        </div>
      </div>
      }
      <div>
        <h2 class="section-header">
          {{ CONGRATS_STATIC_TEXT5 | globalTranslate }}
        </h2>
        <hr />
        @if (rteCaseStatus === 'AP' && !afbRealtimeCrSwitch) {
        <p
          class="static-text"
          [innerHTML]="this.CONGRATS_STATIC_TEXT6 | globalTranslate"
        ></p>
        } @if (rteCaseStatus === 'DN' && !afbRealtimeCrSwitch) {
        <p
          class="static-text"
          [innerHTML]="this.CONGRATS_STATIC_TEXT7 | globalTranslate"
        ></p>
        } @if (rteCaseStatus === 'AP' && idProofScore === 'Y' &&
        afbRealtimeCrSwitch) {
        <p
          class="static-text"
          [innerHTML]="this.CONGRATS_STATIC_TEXT6 | globalTranslate"
        ></p>
        } @if (rteCaseStatus === 'DN' && idProofScore === 'Y' &&
        afbRealtimeCrSwitch) {
        <p
          class="static-text"
          [innerHTML]="this.CONGRATS_STATIC_TEXT7 | globalTranslate"
        ></p>
        } @if (afbRealtimeCrSwitch) {
        <div>
          @if ((rteCaseStatus === 'PE' && idProofScore === 'Y') ||
          !rteCaseStatus) {
          <div class="static-text">
            @if (!isPreterm && !isRMC && !rmbRealTimeSwitch) {
            <p [innerHTML]="this.CONGRATS_STATIC_TEXT8 | globalTranslate"></p>
            } @if (!isPreterm && !isRMC && rmbRealTimeSwitch && !isRmb) {
            <p [innerHTML]="this.CONGRATS_STATIC_TEXT8 | globalTranslate"></p>
            } @if (isPreterm) {
            <p
              [innerHTML]="this.CONGRATS_STATIC_TEXT_QFR1 | globalTranslate"
            ></p>
            } @if (breastCervicalCancerSw === 'Y') {
            <p
              [innerHTML]="this.CONGRATS_STATIC_TEXT_QFR2 | globalTranslate"
            ></p>
            } @if (isPreterm) {
            <p
              [innerHTML]="this.CONGRATS_STATIC_TEXT_QFR3 | globalTranslate"
            ></p>
            } @if (this.isFullMedicAidApp) {
            <p>
              It's okay if you don't have these types of documents right now. We
              will send you a letter asking for these documents if you do not
              have these documents with you right now.
            </p>
            }
          </div>
          }
        </div>
        } @if (!afbRealtimeCrSwitch) {
        <div>
          @if (rteCaseStatus === 'PE' || !rteCaseStatus) {
          <div class="static-text">
            @if (!isPreterm && !isRMC) {
            <p [innerHTML]="this.CONGRATS_STATIC_TEXT8 | globalTranslate"></p>
            } @if (isPreterm) {
            <p
              [innerHTML]="this.CONGRATS_STATIC_TEXT_QFR1 | globalTranslate"
            ></p>
            } @if (breastCervicalCancerSw === 'Y') {
            <p
              [innerHTML]="this.CONGRATS_STATIC_TEXT_QFR2 | globalTranslate"
            ></p>
            } @if (isPreterm) {
            <p
              [innerHTML]="this.CONGRATS_STATIC_TEXT_QFR3 | globalTranslate"
            ></p>
            } @if (this.isFullMedicAidApp) {
            <p>
              It's okay if you don't have these types of documents right now. We
              will send you a letter asking for these documents if you do not
              have these documents with you right now.
            </p>
            }
          </div>
          }
        </div>
        } @if (afbRealtimeCrSwitch && (rteCaseStatus === 'AP' || rteCaseStatus
        === 'DN' || rteCaseStatus === 'APDN' || rteCaseStatus === 'PE') &&
        (idProofScore === 'N'|| !idProofScore ) && !isFullMedicAidApp &&
        !isKepro && !isRmb) {
        <div>
          <p
            class="static-text"
            [innerHTML]="this.CONGRATS_APPEAL_STATIC_TEXT28 | globalTranslate"
          ></p>
          @if (!isNotLinkedAcc && appType === 'AFB') {
          <p>
            {{ CLICK | globalTranslate }}
            <a
              class="page-title-small"
              (click)="moveToLinkMyCase()"
              [attr.aria-label]="LINK_CASE_TITLE"
              tabindex="0"
              ><strong
                ><u style="color: #174a7c">{{
                  LINK_CASE_TITLE | globalTranslate
                }}</u></strong
              ></a
            ><span [innerHTML]="LINK_CASE_TEXT1 | globalTranslate"></span>
          </p>
          }
        </div>
        } @if (afbRealtimeCrSwitch && (rteCaseStatus === 'AP' || rteCaseStatus
        === 'DN' || rteCaseStatus === 'APDN' || rteCaseStatus === 'PE') &&
        (isFullMedicAidApp || isKepro) && !isRmb) {
        <div>
          <p
            class="static-text"
            [innerHTML]="this.CONGRATS_APPEAL_STATIC_TEXT29 | globalTranslate"
          ></p>
        </div>
        }
        <!-- MP-RMC VTC-PP-RMC not real time message-->
        @if (rteCaseStatus === 'RT' || !rteCaseStatus) {
        <div class="static-text">
          @if (!isPreterm && realTimeAppMessage !== 'RT_RMC_SUC' && isRMC &&
          !isKepro) {
          <p
            [innerHTML]="
              this.CONGRATS_STATIC_TEXT_NOT_REAL_TIME8 | globalTranslate
            "
          ></p>
          }
        </div>
        }
        <!-- MP-RMC VTC-PP-RMC real time message-->
        @if (rteCaseStatus === 'RS') {
        <div class="static-text">
          @if (!isPreterm && realTimeAppMessage === 'RT_RMC_SUC' && isRMC &&
          !isKepro) {
          <p
            [innerHTML]="this.CONGRATS_STATIC_TEXT_REAL_TIME8 | globalTranslate"
          ></p>
          }
        </div>
        }
        <!-- AHS RMC not real time message-->
        @if ((rteCaseStatus === 'RT' || !rteCaseStatus) && isKepro) {
        <div class="static-text">
          @if (!isPreterm && realTimeAppMessage !== 'RT_RMC_SUC' && isRMC) {
          <p
            [innerHTML]="
              this.CONGRATS_STATIC_TEXT_AHS_NOT_REAL_TIME8 | globalTranslate
            "
          ></p>
          }
        </div>
        }
        <!-- AHS RMC real time message-->
        @if (rteCaseStatus === 'RS' && isKepro) {
        <div class="static-text">
          @if (!isPreterm && realTimeAppMessage === 'RT_RMC_SUC' && isRMC) {
          <p
            [innerHTML]="this.CONGRATS_STATIC_TEXT_REAL_TIME8 | globalTranslate"
          ></p>
          }
        </div>
        } @if (rteCaseStatus === 'APDN' && !afbRealtimeCrSwitch) {
        <p
          class="static-text"
          [innerHTML]="this.CONGRATS_STATIC_TEXT9 | globalTranslate"
        ></p>
        } @if (rteCaseStatus === 'APDN' && idProofScore === 'Y' &&
        afbRealtimeCrSwitch) {
        <p
          class="static-text"
          [innerHTML]="this.CONGRATS_STATIC_TEXT9 | globalTranslate"
        ></p>
        }
        <!--realTimeRMB-->
        @if (rteCaseStatus === 'AP' && rmbRealTimeSwitch && isRmb && !isPreterm)
        {
        <p
          class="static-text"
          [innerHTML]="this.CONGRATS_RMB_REALTIME_TEXT1 | globalTranslate"
        ></p>
        } @if (rteCaseStatus === 'TN' && rmbRealTimeSwitch && isRmb &&
        !isPreterm) {
        <p
          class="static-text"
          [innerHTML]="this.CONGRATS_RMB_REALTIME_TEXT2 | globalTranslate"
        ></p>
        } @if (rteCaseStatus === 'PE' && rmbRealTimeSwitch && isRmb &&
        !isPreterm && !isKepro) {
        <p
          class="static-text"
          [innerHTML]="this.CONGRATS_RMB_REALTIME_TEXT3 | globalTranslate"
        ></p>
        } @if ((rteCaseStatus === 'PE' || rteCaseStatus?.length > 2) &&
        rmbRealTimeSwitch && isRmb && !isPreterm && isKepro) {
        <p
          class="static-text"
          [innerHTML]="this.CONGRATS_APPEAL_STATIC_TEXT29 | globalTranslate"
        ></p>
        }
        <!-- If status includes 'PE' but is not only 'PE', e.g., 'APPE', 'PEDN'  -->
        <!-- If status does NOT include 'PE' and is status (length > 2), e.g., 'APDN', 'TNDN', 'APTNDN' -->
        @if (((rteCaseStatus !== 'PE' && rteCaseStatus?.includes('PE')) ||
        (!rteCaseStatus?.includes('PE') && rteCaseStatus?.length > 2)) &&
        rmbRealTimeSwitch && isRmb && !isPreterm && !isKepro) {
        <p
          class="static-text"
          [innerHTML]="this.CONGRATS_RMB_REALTIME_TEXT4 | globalTranslate"
        ></p>
        } @if (!rteCaseStatus && rmbRealTimeSwitch && isRmb && !isPreterm) {
        <div>
          @if (isKepro) {
          <p
            class="static-text"
            [innerHTML]="this.CONGRATS_RMB_REALTIME_AHS_TEXT1 | globalTranslate"
          ></p>
          } @if (!isKepro) {
          <p
            class="static-text"
            [innerHTML]="this.CONGRATS_RMB_REALTIME_TEXT5 | globalTranslate"
          ></p>
          }
        </div>
        }
      </div>
      @if (kbDataList?.length > 0 && kbDataList[0]?.kbReferralId !== null) {
      <div>
        <h2 class="section-header">
          {{ CONGRATS_STATIC_TEXT10 | globalTranslate }}
        </h2>
        <hr />
        <p>{{ CONGRATS_STATIC_TEXT11 | globalTranslate }}</p>
        @for (ref of kbDataList; track ref) {
        <p>
          {{ CONGRATS_STATIC_TEXT12 | globalTranslate }}
          {{ ref.name | globalTranslate }}
          {{ CONGRATS_STATIC_TEXT13 | globalTranslate }}
          <strong>{{ ref.kbReferralId }}.</strong><br />{{
            CONGRATS_STATIC_TEXT14 | globalTranslate
          }}
        </p>
        }
        <p>
          {{ CONGRATS_STATIC_TEXT15 | globalTranslate }} @for (ref of
          kbDataList; track ref; let isLast = $last) {
          <span
            >{{ ref.name | globalTranslate
            }}{{ isLast ? "" : (" or " | globalTranslate) }}</span
          >
          } {{ CONGRATS_STATIC_TEXT16 | globalTranslate }}
          <!-- <p [innerHTML]="this.CONGRATS_STATIC_TEXT17"></p> -->
        </p>

        <p class="m-0">{{ CONGRATS_STATIC_TEXT18 | globalTranslate }}</p>
        <ul>
          <li>
            <strong>{{ CONGRATS_STATIC_TEXT19 | globalTranslate }}: </strong>
            901-745-7200 or 800-308-2586
          </li>
          <li>
            <strong>{{ CONGRATS_STATIC_TEXT20 | globalTranslate }}: </strong>
            615-231-5047
          </li>
          <li>
            <strong>{{ CONGRATS_STATIC_TEXT21 | globalTranslate }}: </strong>
            865-588-0508
          </li>
        </ul>
        <br />
      </div>
      } @if (ecfIndicator === 'Y') {
      <div class="mt-4">
        <h2 class="section-header">
          {{ CONGRATS_STATIC_TEXT22 | globalTranslate }}
        </h2>
        <hr />
        <p>{{ CONGRATS_STATIC_TEXT23 | globalTranslate }}</p>
        <p>
          {{ CONGRATS_STATIC_TEXT24 | globalTranslate
          }}<a
            class="a-link"
            href="https://perlss.tenncare.tn.gov/externalreferral"
            [title]="CONGRATS_STATIC_TEXT25"
            [attr.aria-label]="CONGRATS_STATIC_TEXT25"
            ><b>{{ CONGRATS_STATIC_TEXT25 | globalTranslate }}</b></a
          >. {{ CONGRATS_STATIC_TEXT26 | globalTranslate }}
        </p>
        <p class="m-0">{{ CONGRATS_STATIC_TEXT27 | globalTranslate }}</p>
        <ul>
          <li>
            <span class="pe-5"
              >{{ CONGRATS_STATIC_TEXT19 | globalTranslate }} Tennessee</span
            ><span class="pl-3">866-372-5709</span>
          </li>
          <li>
            <span class="pe-5"
              >{{ CONGRATS_STATIC_TEXT20 | globalTranslate }} Tennessee</span
            >800-654-4839
          </li>
          <li>
            <span class="pe-5"
              >{{ CONGRATS_STATIC_TEXT21 | globalTranslate }} Tennessee</span
            ><span class="pl-4">888-531-9876</span>
          </li>
          <br />
        </ul>
      </div>
      }
      <!-- <div *ngIf="!isNotLinkedAcc && appType === 'AFB'">
                        <nh-alert type="warning" [isOpen]="linkyourcase">
                          <div class="row">
                            <div class="col-auto icon">
                              <img src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg" alt="warning" />
                            </div>
                            <div class="col message">
                              <strong>{{LINK_YOUR_CASE_HEADER| globalTranslate }}</strong><br>
                            </div>
                          </div><br>
                          <p>{{CLICK| globalTranslate }} <a class="page-title-small" (click)="moveToLinkMyCase()"><strong><u style="color:#174a7c">{{HERE| globalTranslate }}</u></strong></a><span [innerHTML]="LINK_YOUR_CASE_FOR_LETTERS | globalTranslate"></span>
                        </p>
                      </nh-alert>
                    </div> -->
      @if (isNotLinkedAcc) {
      <div>
        <nh-alert type="warning" [isOpen]="showCommPref">
          <div class="row">
            <div class="col-auto icon">
              <img
                src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                alt=""
              />
            </div>
            <div class="col message">
              <span class="visually-hidden"
                >{{ Alert | globalTranslate }}
              </span>
              <strong>{{
                COMM_PREF_FINISHMODULE_BANNER_TEXT1 | globalTranslate
              }}</strong
              ><br />
            </div>
          </div>
          <br />
          <p>
            {{ CLICK | globalTranslate }}
            <a
              class="communication-link"
              href="#"
              title="{{ CMP_LINK | globalTranslate }}"
              (click)="moveToCommPref($event)"
              tabindex="0"
              >{{ HERE | globalTranslate }}</a
            >
            <span
              [innerHTML]="
                COMM_PREF_FINISHMODULE_BANNER_TEXT2 | globalTranslate
              "
            ></span>
            <span
              ><b
                [innerHTML]="
                  COMM_PREF_FINISHMODULE_BANNER_TEXT2_01 | globalTranslate
                "
              ></b
              >.</span
            >
            <span
              [innerHTML]="
                COMM_PREF_FINISHMODULE_BANNER_TEXT2_02 | globalTranslate
              "
            ></span>
          </p>
        </nh-alert>
      </div>
      } @if (isNotLinkedAcc) {
      <div>
        <h2 class="section-header">
          <strong>{{ CHANGE_HOW_LETTERS | globalTranslate }}</strong>
        </h2>
        <hr />
        <p>
          {{ CHANGE_LETTERS_STATIC_TEXT1 | globalTranslate }}
          {{ CLICK | globalTranslate }}
          <a
            class="communication-link"
            href="#"
            title="{{ CMP_LINK | globalTranslate }}"
            (click)="moveToCommPref($event)"
            tabindex="0"
            >{{ HERE | globalTranslate }}</a
          >
          {{ CHANGE_LETTERS_STATIC_TEXT2 | globalTranslate }}
        </p>
      </div>
      }
      <div class="mt-4">
        @if (!isChangeMode && !isPreterm) {
        <h2 class="section-header">
          <strong
            >@if (!isPreterm) {
            <span
              >{{ CONGRATS_STATIC_TEXT28 | globalTranslate }}
              {{ appKeyWord | globalTranslate }}</span
            >
            }</strong
          >
        </h2>
        } @if (!isChangeMode && isPreterm) {
        <h2 class="section-header">
          <strong
            >@if (isPreterm) {
            <span
              >{{ CONGRATS_STATIC_TEXT_QFR8 | globalTranslate }}
              {{ appKeyWord | globalTranslate }}</span
            >
            }</strong
          >
        </h2>
        } @if (isChangeMode) {
        <h2 class="section-header">
          <strong>{{ CONGRATS_STATIC_TEXT40 | globalTranslate }}</strong>
        </h2>
        }
        <hr />
        @if (!isPreterm) {
        <p [innerHTML]="this.CONGRATS_STATIC_TEXT29 | globalTranslate"></p>
        } @if (isPreterm) {
        <p [innerHTML]="this.CONGRATS_STATIC_TEXT_QFR4 | globalTranslate"></p>
        }
        <p>{{ CONGRATS_STATIC_TEXT30 | globalTranslate }}</p>
        <ul class="mb-3 ms-4 print-list">
          <li>{{ CONGRATS_STATIC_TEXT31 | globalTranslate }}</li>
          <li>{{ CONGRATS_STATIC_TEXT32 | globalTranslate }}</li>
          <li>{{ CONGRATS_STATIC_TEXT33 | globalTranslate }}</li>
        </ul>
        <p>
          <span [innerHTML]="CONGRATS_STATIC_TEXT34 | globalTranslate"></span>
          <span
            ><b [innerHTML]="CONGRATS_STATIC_TEXT34_01 | globalTranslate"></b
          ></span>
          <span
            [innerHTML]="CONGRATS_STATIC_TEXT34_02 | globalTranslate"
          ></span>
        </p>
        <div class="mb-3 mt-4">
          <button
            class="col-md-5 btn btn-secondary-congrats"
            (click)="printPdf()"
            [attr.aria-label]="CONGRATS_STATIC_TEXT35"
          >
            {{ CONGRATS_STATIC_TEXT35 | globalTranslate }}
            <img src="../../assets/images/printw.svg" alt="print-icon" />
          </button>
        </div>
      </div>
      <p>
        @if (!isPreterm) {
        <span>{{ CONGRATS_STATIC_TEXT36 | globalTranslate }}</span>
        }@if (isPreterm) {
        <span>{{ CONGRATS_STATIC_TEXT_QFR9 | globalTranslate }}</span>
        } {{ appKeyWord | globalTranslate }}
        {{ CONGRATS_STATIC_TEXT42 | globalTranslate }}
        {{ CONGRATS_STATIC_TEXT41 | globalTranslate }}
        @if (!this.isFullCoverageApp) {
        <a
          class="a-link"
          href="#"
          (click)="openFaqInNewTab($event)"
          [attr.aria-label]="CONGRATS_STATIC_TEXT37"
          [title]="CONGRATS_STATIC_TEXT37"
          ><strong>{{ CONGRATS_STATIC_TEXT37 | globalTranslate }}</strong></a
        >
        } @if (this.isFullCoverageApp) {
        <a
          class="a-link"
          href="#"
          (click)="openFaqInNewTab($event, 'RP')"
          [attr.aria-label]="CONGRATS_STATIC_TEXT37"
          [title]="CONGRATS_STATIC_TEXT37"
          ><strong>{{ CONGRATS_STATIC_TEXT37 | globalTranslate }}</strong></a
        >
        }
      </p>
      @if (!isKepro && (afbRealtimeCrSwitch || rmbRealTimeSwitch)) {
      <div>
        @if (isFullMedicAidApp && !rteCaseStatus) {
        <div class="mb-3 mt-4">
          <button
            class="col-md-5 btn btn-secondary-congrats"
            (click)="goToDocuments()"
            [ngClass]="{ 'height-translate': increaseHeight() }"
            [attr.aria-label]="CONGRATS_STATIC_TEXT38"
          >
            {{ CONGRATS_STATIC_TEXT38 | globalTranslate }}
            <img src="../../assets/images/cloudupload.svg" alt="upload icon" />
          </button>
        </div>
        } @if (!isPartner) {
        <div>
          @if (rmbRealTimeSwitch && isRmb && !isPreterm &&
          (rteCaseStatus?.includes('PE') || !rteCaseStatus)) {
          <div class="mb-3 mt-4">
            <button
              class="col-md-5 btn btn-secondary-congrats"
              (click)="goToDocuments()"
              [ngClass]="{ 'height-translate': increaseHeight() }"
              [attr.aria-label]="CONGRATS_STATIC_TEXT38"
            >
              {{ CONGRATS_STATIC_TEXT38 | globalTranslate }}
              <img
                src="../../assets/images/cloudupload.svg"
                alt="upload icon"
              />
            </button>
          </div>
          } @if (afbRealtimeCrSwitch && (rteCaseStatus === 'PE' ||
          !rteCaseStatus) && !isRmb && !isRMC) {
          <div class="mb-3 mt-4">
            <button
              class="col-md-5 btn btn-secondary-congrats"
              (click)="goToDocuments()"
              [ngClass]="{ 'height-translate': increaseHeight() }"
              [attr.aria-label]="CONGRATS_STATIC_TEXT38"
            >
              {{ CONGRATS_STATIC_TEXT38 | globalTranslate }}
              <img
                src="../../assets/images/cloudupload.svg"
                alt="upload icon"
              />
            </button>
          </div>
          }
          <!-- MP-RMC doc upload button -->
          @if (isRMC && (rteCaseStatus === 'RT' || !rteCaseStatus)) {
          <div class="mb-3 mt-4">
            <button
              class="col-md-5 btn btn-secondary-congrats"
              (click)="goToDocuments()"
              [ngClass]="{ 'height-translate': increaseHeight() }"
              [attr.aria-label]="CONGRATS_STATIC_TEXT38"
            >
              {{ CONGRATS_STATIC_TEXT38 | globalTranslate }}
              <img
                src="../../assets/images/cloudupload.svg"
                alt="upload icon"
              />
            </button>
          </div>
          }
        </div>
        } @if (isPartner && rmbRealTimeSwitch && !isFullMedicAidApp && !isRMC) {
        <div>
          @if ((!rteCaseStatus || rteCaseStatus?.includes('PE'))) {
          <div class="mb-3 mt-4">
            <button
              class="col-md-5 btn btn-secondary-congrats"
              (click)="goToDocuments()"
              [ngClass]="{ 'height-translate': increaseHeight() }"
              [attr.aria-label]="CONGRATS_STATIC_TEXT38"
            >
              {{ CONGRATS_STATIC_TEXT38 | globalTranslate }}
              <img
                src="../../assets/images/cloudupload.svg"
                alt="upload icon"
              />
            </button>
          </div>
          }
        </div>
        }
        <!-- PP-VTC-RMC doc upload button -->
        @if (isPartner && isRMC) {
        <div>
          @if ((rteCaseStatus === 'RT' || !rteCaseStatus)) {
          <div class="mb-3 mt-4">
            <button
              class="col-md-5 btn btn-secondary-congrats"
              (click)="goToDocuments()"
              [ngClass]="{ 'height-translate': increaseHeight() }"
              [attr.aria-label]="CONGRATS_STATIC_TEXT38"
            >
              {{ CONGRATS_STATIC_TEXT38 | globalTranslate }}
              <img
                src="../../assets/images/cloudupload.svg"
                alt="upload icon"
              />
            </button>
          </div>
          }
        </div>
        }
      </div>
      }
      <!-- MP-RMB,VTC-RMB not realtimeCRswitch -->
      @if (!isKepro && (!afbRealtimeCrSwitch || (!rmbRealTimeSwitch && isRmb &&
      !isPreterm))) {
      <div>
        @if (rteCaseStatus === 'PE' || !rteCaseStatus) {
        <div class="mb-3 mt-4">
          <button
            class="col-md-5 btn btn-secondary-congrats"
            (click)="goToDocuments()"
            [ngClass]="{ 'height-translate': increaseHeight() }"
            [attr.aria-label]="CONGRATS_STATIC_TEXT38"
          >
            {{ CONGRATS_STATIC_TEXT38 | globalTranslate }}
            <img src="../../assets/images/cloudupload.svg" alt="upload icon" />
          </button>
        </div>
        }
      </div>
      }
    </div>
  </section>
  } @if (!isAppeals && !isFinReassessment) {
  <br />
  } @if (!isPresumptive && !isAdmitDischarge && !isNewborn && !isFinReassessment
  && !isAppeals && !isBCCEXT && !isIME) {
  <div class="me-3 pr-md-1 py-sm-1">
    <button
      id="continue"
      class="btn btn-secondary ms-1"
      (click)="navigateNext()"
      [attr.aria-label]="CONGRATS_STATIC_TEXT39"
    >
      {{ CONGRATS_STATIC_TEXT39 | globalTranslate }}
    </button>
  </div>
  } @if (isPresumptive) {
  <section class="border bg-white p-3">
    <div class="p-3">
      <h1 class="section-header">Confirmation of Your Submission</h1>
      <hr />
      <div>
        <p>
          Save this as a confirmation of your submission by clicking the
          <strong>Print</strong> button at the bottom of this screen. You can
          also access this information at any time via the
          <a
            href="/api/prov/submission-search"
            aria-label="Search My Submissions"
            title="Search My Submissions"
            ><b>Search My Submissions</b>
          </a>
          Page.
        </p>
        <p>
          You must print this page and give it to the applicant to keep. It has
          important information that may help them later.
        </p>
      </div>
      @if ((isPresumptive && workerPortalAppNum && showTracking)) {
      <div>
        <h2 class="section-header">Track Your Application</h2>
        <hr />
        <p>
          Your application tracking number is
          <strong>{{ workerPortalAppNum | globalTranslate }}</strong
          >. To check the status of your application, log in to your TennCare
          Connect account and go to the Search My Submissions.
        </p>
      </div>
      } @if (ecfIndicator === 'Y') {
      <div class="mt-4">
        <h2 class="section-header">
          About Your Self-Referral for Employment and Community First Choices
        </h2>
        <hr />
        <p>
          The Employment and Community First CHOICES program is for people of
          all ages who have an intellectual or developmental disability (I/DD)
          including people who have significant disabilities. Services in the
          program can help you learn skills to become employed and live as
          independently as possible in the community.
        </p>
        <p>
          To see if you can be served through this program, you must
          <a
            class="a-link"
            href="https://perlss.tenncare.tn.gov/externalreferral"
            aria-label="complete the self-referral form"
            title="complete the self-referral form"
            >complete the self-referral form</a
          >. *Clicking this link will take you away from TennCare Connect and
          you will be logged out.
        </p>
        <p>
          Do you have questions about a referral? Call the DIDD regional office
          in your area for free:
        </p>
        <ul>
          <li>West Tennesse 866-372-5709</li>
          <li>Middle Tennessee 800-654-4839</li>
          <li>East Tennessee 888-531-9876</li>
        </ul>
      </div>
      }
      <div class="mt-4">
        <h2 class="section-header">Print the Application</h2>
        <hr />
        <p>
          <strong
            >You must give the applicant(s) a copy of the application. Before
            you print the application, remember that it includes private,
            personal information.
          </strong>
        </p>
        <p>To print, click the <strong>Print</strong> button below.</p>
        <div class="mb-3 mt-4">
          <button
            class="col-md-5 btn btn-secondary-congrats"
            aria-label="Print"
            (click)="printPdf()"
          >
            Print
            <img src="../../assets/images/printw.svg" alt="print-icon" />
          </button>
        </div>
      </div>
      @if (isPresumptive) {
      <div>
        <h2 class="section-header">Presumptive Eligibility Results</h2>
        <hr />
        <p class="mt-2">
          The table below shows the Presumptive Eligibility decision.
        </p>
        <ngx-datatable
          class="bootstrap striped"
          #table
          [rows]="results"
          [columnMode]="'force'"
          [headerHeight]="'auto'"
          [footerHeight]="50"
          [rowHeight]="'auto'"
        >
          <ngx-datatable-column name="Name">
            <ng-template
              ngx-datatable-cell-template
              let-row="row"
              let-rowIndex="rowIndex"
            >
              {{ row?.name | globalTranslate }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Gender">
            <ng-template
              ngx-datatable-cell-template
              let-row="row"
              let-rowIndex="rowIndex"
            >
              {{ row?.gender?.value | globalTranslate }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Date of Birth">
            <ng-template
              ngx-datatable-cell-template
              let-row="row"
              let-rowIndex="rowIndex"
            >
              {{ row?.dob | globalTranslate }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Status">
            <ng-template
              ngx-datatable-cell-template
              let-row="row"
              let-rowIndex="rowIndex"
            >
              {{ row?.status | globalTranslate }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Eligibility Begin Date">
            <ng-template
              ngx-datatable-cell-template
              let-row="row"
              let-rowIndex="rowIndex"
            >
              {{ row?.eligibleBeginDate | globalTranslate }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Eligibility End Date">
            <ng-template
              ngx-datatable-cell-template
              let-row="row"
              let-rowIndex="rowIndex"
            >
              {{ row?.eligibleEndDate | globalTranslate }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Eligibility Category">
            <ng-template
              ngx-datatable-cell-template
              let-row="row"
              let-rowIndex="rowIndex"
            >
              {{ row?.eligCategory?.value | globalTranslate }}
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
      } @if (isApproved) {
      <p>
        If approved for presumptive, the health plan and TennCare Online
        Services will be updated within 2-3 business days.
      </p>
      <br />
      } @if (isDenied) {
      <p>
        If denied for presumptive, the applicant can still apply for coverage at
        <a href="https://tenncareconnect.tn.gov"
          ><b>https://tenncareconnect.tn.gov</b></a
        >
      </p>
      } @if (hideFullCoverage !== 'YES') {
      <div>
        <h2 class="section-header">Full Coverage Application</h2>
        <hr />
        <div class="static-text">
          @if (rteCaseStatus && enableSameDayDocUploadForPEFC) {
          <p
            class="static-text"
            [innerHTML]="this.CONGRATS_APPEAL_STATIC_TEXT29 | globalTranslate"
          ></p>
          } @if (!rteCaseStatus && enableSameDayDocUploadForPEFC) {
          <div>
            <p>
              We're reviewing your information now. If we need more information
              from you, you'll get a letter that tells you what's needed. The
              letter will also tell you when the information is due.
            </p>
            <p>
              Or, If we can make a decision with the facts we have, we'll send a
              letter that tells you what we decide.
            </p>
            <p>
              You can also click the <b>Upload Documents</b> button below if you
              want to upload documents now that we may ask you for after we are
              finished reviewing your application.
            </p>
          </div>
          } @if (!enableSameDayDocUploadForPEFC) {
          <div>
            <p>
              We're reviewing your information now. If we need more information
              from you, you'll get a letter that tells you what's needed. The
              letter will also tell you when the information is due.
            </p>
            <p>
              Or, If we can make a decision with the facts we have, we'll send a
              letter that tells you what we decide.
            </p>
            <p>
              You can also click the <b>Upload Documents</b> button below if you
              want to upload documents now that we may ask you for after we are
              finished reviewing your application.
            </p>
          </div>
          } @if (breastCervicalCancerSw === 'Y' && appType !== 'BCC') {
          <p [innerHTML]="this.CONGRATS_STATIC_TEXT_QFR2 | globalTranslate"></p>
          } @if (!rteCaseStatus && enableSameDayDocUploadForPEFC) {
          <p>
            It's okay if you don't have these types of documents right now. We
            will send you a letter asking for these documents if you do not have
            these documents with you right now.
          </p>
          } @if (!enableSameDayDocUploadForPEFC) {
          <p>
            It's okay if you don't have these types of documents right now. We
            will send you a letter asking for these documents if you do not have
            these documents with you right now.
          </p>
          }
          <div class="row me-4">
            <button
              class="col-md-3 btn btn-secondary-congrats"
              (click)="goToDocuments()"
              aria-label="Upload Documents"
            >
              Upload Documents
              <img
                src="../../assets/images/cloudupload.svg"
                alt="upload icon"
              />
            </button>
          </div>
        </div>
      </div>
      }
    </div>
    <div class="row g-3">
      <div class="col-12 col-md-5">
        <button
          class="ms-5 btn btn-secondary"
          (click)="onNextClick()"
          aria-label="Exit"
        >
          Exit
        </button>
      </div>
    </div>
  </section>
  } @if (isAdmitDischarge) {
  <section class="border bg-white p-3">
    <div class="p-3">
      <p>The date of submission is</p>
      <p>
        <strong>
          {{ appSubmittedDate | date: "longDate" | globalTranslate }}
        </strong>
      </p>
      <h1 class="section-header">Confirmation of Your Submission</h1>
      <hr />
      <div>
        <p>
          To save this confirmation page, click <b>Print</b> button at the
          bottom of this screen. From there, you can print this page for your
          records or download it to your computer. Remember, you can also see
          this submission at anytime on the
          <a
            (click)="onSearchClick()"
            class="view-tennCare-title"
            aria-label="Search My Submissions"
            tabindex="0"
            >Search My Submissions</a
          >
          page.
        </p>
        <p>
          You can print this page and give it to the applicant to keep. It has
          important information that may help them later.
        </p>
      </div>
      <h2 class="section-header">What Happens Next</h2>
      <hr />
      <p>
        We're reviewing this information now. If we need more information, we'll
        send a letter to the patient and the Assisting Person (if there is one).
        The letter will say what information is needed and when it is due.
      </p>
      <p>We'll send another letter when we make our decision.</p>
      <h2 class="section-header">
        Print this 2350 Form (Admit/Discharge Form)
      </h2>
      <hr />
      <p>
        <strong
          >Before you print this form, remember that it includes private,
          personal information.</strong
        >
      </p>
      <p>To print, click <strong>Print</strong> button below.</p>
      <div class="row justify-content-start me-4">
        <button
          class="btn btn-secondary-congrats"
          (click)="printPdf()"
          aria-label="Print"
        >
          Print
          <img src="../../assets/images/printw.svg" alt="print-icon" />
        </button>
      </div>
      <br />
      <p>
        If you're having trouble printing your application, check our
        <a
          class="view-tennCare-title"
          href="#"
          (click)="openFaqInNewTab($event, 'RP')"
          aria-label="FAQ"
          title="FAQ"
          ><strong><u>FAQ</u></strong></a
        >
        page.
      </p>
    </div>
  </section>
  } @if (isNewborn) {
  <section class="border bg-white p-3">
    <div class="p-3">
      <p>The date of submission is</p>
      <p>
        <strong>
          {{ appSubmittedDate | date: "longDate" | globalTranslate }}
        </strong>
      </p>
      <h1 class="section-header">Confirmation of Your Submission</h1>
      <hr />
      <div>
        <p>
          To save this confirmation page, click <b>Print</b> button at the
          bottom of this screen. From there, you can print this page for your
          records or download it to your computer. Remember, you can also see
          this submission at anytime on the
          <a
            (click)="onSearchClick()"
            class="page-title-small"
            tabindex="0"
            aria-label="My
          Submissions"
            ><strong>My Submissions</strong></a
          >
          page.
        </p>
        <p>
          You can print this page and give it to the applicant to keep. It has
          important information that may help them later.
        </p>
      </div>
      <h2 class="section-header">What Happens Next</h2>
      <hr />
      <p>
        We're reviewing this information now. If we need more information, we'll
        send a letter to the applicant.
      </p>
      <p>
        You will also receive this letter if you listed yourself as the
        Assisting Person and have permission to receive the applicant's letters.
      </p>
      <h2 class="section-header">Print Your Newborn Form</h2>
      <hr />
      <p>
        <strong
          >Before you print newborn form, remember that it includes private,
          personal information.</strong
        >
      </p>
      <p>To print, click <strong>Print</strong> button below.</p>
      <div class="row justify-content-start me-4">
        <button
          class="col-md-5 btn btn-secondary-congrats"
          (click)="printPdf()"
          aria-label="Print"
        >
          Print
          <img src="../../assets/images/printw.svg" alt="print-icon" />
        </button>
      </div>
      <br />
      <p>
        If you're having trouble printing your application, check our
        <a
          class="page-title-small"
          href="#"
          (click)="openFaqInNewTab($event, 'RP')"
          aria-label="FAQ"
          title="FAQ"
          ><strong><u>FAQ</u></strong></a
        >
        page.
      </p>
    </div>
  </section>
  } @if (isBCCEXT) {
  <section class="border bg-white p-3">
    <div class="p-3">
      <p>
        This request was submitted to TennCare on<strong>
          {{ appSubmittedDate | date: "longDate" | globalTranslate }}
        </strong>
      </p>
      <h1 class="section-header">Confirmation of Your Submission</h1>
      <hr />
      <div>
        <p>
          To save this confirmation page, click <b>Print</b> button at the
          bottom of this screen. From there, you can print this page for your
          records or download it to your computer. Remember, you can also see
          this submission at anytime on the
          <a
            (click)="onSearchClick()"
            class="page-title-small"
            tabindex="0"
            aria-label="My
          Submissions"
            ><strong>My Submissions</strong></a
          >
          page.
        </p>
        <p>
          You can print this page and give it to the applicant to keep. It has
          important information that may help them later.
        </p>
      </div>
      <h2 class="section-header">Track Your Application</h2>
      <hr />
      <p>
        Your BCC Treatment Plan Extension Request Form tracking number is
        <strong>{{ workerPortalAppNum | globalTranslate }}</strong
        >.
      </p>
      <p>
        To check the status of your application, log in to your TennCare Connect
        account and go to the My Submissions page.
      </p>
      <h2 class="section-header">
        Print this BCC Treatment Plan Extension Request Form
      </h2>
      <hr />
      <p>
        <strong
          >Before you print this form, remember that it includes private,
          personal information.</strong
        >
      </p>
      <p>To print, click <strong>Print</strong> button below.</p>
      <div class="row justify-content-start me-4">
        <button
          class="col-md-5 btn btn-secondary-congrats"
          (click)="printPdf()"
          aria-label="Print"
        >
          Print
          <img src="../../assets/images/printw.svg" alt="print-icon" />
        </button>
      </div>
      <br />
      <p>
        If you're having trouble printing your application, check our
        <a
          class="page-title-small"
          href="#"
          (click)="openFaqInNewTab($event, 'RP')"
          aria-label="FAQ"
          title="FAQ"
          ><strong><u>FAQ</u></strong></a
        >
        page.
      </p>
      <h2 class="section-header">What Happens Next</h2>
      <hr />
      <p>
        We're reviewing the application now. If we need more information to make
        a decision, we'll send a letter to the applicant.
      </p>
      <p>
        You will also receive this letter if you listed yourself as the
        Assisting Person and have permission to receive the applicant's letters.
      </p>
    </div>
  </section>
  } @if (isIME) {
  <section class="border bg-white p-3">
    <div class="p-3">
      <p>The date of submission is</p>
      <p>
        <strong>
          {{ appSubmittedDate | date: "longDate" | globalTranslate }}
        </strong>
      </p>
      <h1 class="section-header">Confirmation of Your Submission</h1>
      <hr />
      <div>
        <p>
          To save this confirmation page, click <b>Print</b> button below. From
          there, you can print this page for your records or download it to your
          computer. Remember, you can also see this submission at anytime on the
          <a
            (click)="onSearchClick()"
            class="view-tennCare-title"
            aria-label="My Submissions"
            tabindex="0"
            ><strong>My Submissions</strong></a
          >
          page.
        </p>
        <p>
          You can print this page and give it to the applicant to keep. It has
          important information that may help them later.
        </p>
      </div>
      <h2 class="section-header">Track Your Submission</h2>
      <hr />
      <p>
        Your Incurred Medical Expense Form tracking number is
        <strong>{{ workerPortalAppNum | globalTranslate }}</strong
        >.
      </p>
      <p>
        To check the status of your submission, log in to your TennCare Connect
        account and go to the My Submissions page.
      </p>
      <h2 class="section-header">Print this Incurred Medical Expense Form</h2>
      <hr />
      <p>
        <strong
          >Before you print this form, remember that it includes private,
          personal information.</strong
        >
      </p>
      <p>To print, click <strong>Print</strong> button below.</p>
      <div class="row justify-content-start me-4">
        <button
          class="btn btn-secondary-congrats"
          (click)="printPdf()"
          aria-label="Print"
        >
          Print
          <img src="../../assets/images/printw.svg" alt="print-icon" />
        </button>
      </div>
      <br />
      <p>
        If you're having trouble printing your form, check our
        <a
          class="view-tennCare-title"
          href="#"
          (click)="openFaqInNewTab($event, 'RP')"
          title="FAQ page"
          aria-label="FAQ page"
          ><strong>FAQ page.</strong></a
        >
      </p>
      <h2 class="section-header">What Happens Next</h2>
      <hr />
      <p>
        We're reviewing this information now. If we need more information, we'll
        send a letter to the patient and the Assisting Person (if there is one).
        The letter will say what information is needed and when it is due.
      </p>
      <p>We'll send another letter when we make our decision.</p>
    </div>
  </section>
  } @if (!isAppeals && !isFinReassessment) {
  <br />
  } @if (isAdmitDischarge || isNewborn || isBCCEXT || isIME) {
  <div class="row g-3">
    <div class="col-lg-5">
      <div class="justify-content-center">
        <button
          id="tenncare-prm-btn"
          class="btn btn-block btn-primary"
          (click)="onNextClick()"
          aria-label="RETURN TO TENNCARE ACCESS HOME"
        >
          RETURN TO TENNCARE ACCESS HOME
        </button>
      </div>
    </div>
    <div class="col-lg-5">
      <div class="justify-content-center">
        <button
          id="tencare-sec-btn"
          class="btn btn-block btn-outline-secondary"
          (click)="onSearchClick()"
          aria-label="GO TO SEARCH MY SUBMISSIONS"
        >
          GO TO SEARCH MY SUBMISSIONS
        </button>
      </div>
    </div>
  </div>
  } @if (!isAppeals && !isFinReassessment) {
  <br />
  } @if (!isAppeals && !isFinReassessment) {
  <br />
  } @if (isFinReassessment) {
  <section class="border bg-white p-3">
    <div class="p-3">
      <h1 class="section-header">Confirmation of Your Submission</h1>
      <hr />
      <div>
        <p>
          To save this confirmation page, click <b>Print</b> button at the
          bottom of this screen. From there, you can print this page for your
          records or download it to your computer. Remember, you can also see
          this submission at anytime on the&nbsp;<a
            (click)="onSearchClick()"
            class="page-title-small"
            tabindex="0"
            aria-label="Search My
          Submissions"
            >Search My Submissions</a
          >&nbsp;page.
        </p>
        <p>
          You can print this page and give it to the applicant to keep. It has
          important information that may help them later.
        </p>
      </div>
      @if (workerPortalAppNum) {
      <div>
        <h2 class="section-header">Track Your Application</h2>
        <hr />
        <p>
          Your reassessment tracking number is
          <strong>{{ workerPortalAppNum | globalTranslate }}</strong
          >.
        </p>
        <p>
          To check the status of your application, log in to your TennCare
          Connect account and go to the Search My Submissions.
        </p>
      </div>
      } @if (ecfIndicator === 'Y') {
      <div class="mt-4">
        <h2 class="section-header">
          About Your Self-Referral for Employment and Community First Choices
        </h2>
        <hr />
        <p>
          The Employment and Community First CHOICES program is for people of
          all ages who have an intellectual or developmental disability (I/DD)
          including people who have significant disabilities. Services in the
          program can help you learn skills to become employed and live as
          independently as possible in the community.
        </p>
        <p>
          To see if you can be served through this program, you must
          <a
            class="a-link"
            href="https://perlss.tenncare.tn.gov/externalreferral"
            aria-label="complete the self-referral form"
            title="complete the self-referral form"
            >complete the self-referral form</a
          >. *Clicking this link will take you away from TennCare Connect and
          you will be logged out.
        </p>
        <p>
          Do you have questions about a referral? Call the DIDD regional office
          in your area for free:
        </p>
        <ul>
          <li>West Tennesse 866-372-5709</li>
          <li>Middle Tennessee 800-654-4839</li>
          <li>East Tennessee 888-531-9876</li>
        </ul>
      </div>
      }
      <div class="mt-4">
        <h2 class="section-header">Print the Financial Reassessment</h2>
        <hr />
        <p>
          <strong
            >Before you print the Financial Reassessment, remember that it
            includes private, personal information.
          </strong>
        </p>
        <p>To print, click <strong>Print</strong> button below.</p>
        <div class="mb-3 mt-4">
          <button
            class="col-md-5 btn btn-secondary-congrats"
            (click)="printPdf()"
            aria-label="Print"
          >
            Print
            <img src="../../assets/images/printw.svg" alt="print-icon" />
          </button>
        </div>
      </div>
      <h2 class="section-header">What Happens Next</h2>
      <hr />
      @if (rteCaseStatus === 'AP' && rmbRealTimeSwitch) {
      <p
        class="static-text"
        [innerHTML]="this.CONGRATS_RMB_REALTIME_TEXT1 | globalTranslate"
      ></p>
      } @if (rteCaseStatus === 'TN' && rmbRealTimeSwitch) {
      <p
        class="static-text"
        [innerHTML]="this.CONGRATS_RMB_REALTIME_TEXT2 | globalTranslate"
      ></p>
      } @if (rteCaseStatus === 'PE' && rmbRealTimeSwitch) {
      <p
        class="static-text"
        [innerHTML]="this.CONGRATS_RMB_REALTIME_TEXT3 | globalTranslate"
      ></p>
      } @if ((!rteCaseStatus && rmbRealTimeSwitch) || !rmbRealTimeSwitch) {
      <div>
        <p>
          We're reviewing your information now. If we need more information from
          you, you'll get a letter that tells you what's needed. The letter will
          also tell you when the information is due.
        </p>
        <p>
          Or, if we can make a decision with the facts we have, we'll send a
          letter that tells you what we decide.
        </p>
        <p>
          You can also click the <b>Upload Documents</b> button below if you
          want to upload documents now that we may ask you for after we are
          finished reviewing your application.
        </p>
      </div>
      } @if (breastCervicalCancerSw === 'Y') {
      <p [innerHTML]="this.CONGRATS_STATIC_TEXT_QFR2 | globalTranslate"></p>
      } @if ((!rteCaseStatus && rmbRealTimeSwitch) || !rmbRealTimeSwitch) {
      <p>
        It's okay if you don't have these types of documents right now. We will
        send you a letter asking for these documents if you do not have these
        documents with you right now.
      </p>
      }
      <!-- If status includes 'PE' but is not only 'PE', e.g., 'APPE', 'PEDN'  -->
      <!-- If status does NOT include 'PE' and is status (length > 2), e.g., 'APDN', 'TNDN', 'APTNDN' -->
      @if (((rteCaseStatus !== 'PE' && rteCaseStatus?.includes('PE')) ||
      (!rteCaseStatus?.includes('PE') && rteCaseStatus?.length > 2)) &&
      rmbRealTimeSwitch) {
      <p
        class="static-text"
        [innerHTML]="this.CONGRATS_STATIC_TEXT9 | globalTranslate"
      ></p>
      } @if (!rmbRealTimeSwitch) {
      <div class="row me-4">
        <button
          class="col-md-3 btn btn-secondary-congrats"
          (click)="goToDocuments()"
          aria-label="Upload Documents"
        >
          Upload Documents
          <img src="../../assets/images/cloudupload.svg" alt="upload icon" />
        </button>
      </div>
      } @if (rmbRealTimeSwitch && (rteCaseStatus?.includes('PE') ||
      !rteCaseStatus)) {
      <div class="row me-4">
        <button
          class="col-md-3 btn btn-secondary-congrats"
          (click)="goToDocuments()"
          aria-label="Upload Documents"
        >
          Upload Documents
          <img src="../../assets/images/cloudupload.svg" alt="upload icon" />
        </button>
      </div>
      }
    </div>
  </section>
  } @if (isFinReassessment && !isKbUser) {
  <div class="me-3 pr-md-1 py-sm-1 mt-5 mb-2">
    <button
      id="continue"
      class="btn btn-secondary ms-1"
      [routerLink]="['/user-profile', 'benefit-dashboard']"
      aria-label="Next"
    >
      Next
    </button>
  </div>
  } @if (isFinReassessment && isKbUser) {
  <div class="me-3 pr-md-1 py-sm-1 mt-5 mb-2">
    <button
      id="continue"
      class="btn btn-secondary ms-1"
      (click)="backToMemberSearch()"
      aria-label="Next"
    >
      Next
    </button>
  </div>
  } @if (isAppeals) {
  <div>
    <section>
      <h1 class="page-title mt-0">
        {{ CONGRATS_APPEAL_STATIC_TEXT | globalTranslate }}
      </h1>
    </section>
    <section class="border bg-white p-3">
      <section class="p-2">
        <div class="row">
          <div class="col">
            @if (appealSummaryInfo.length <= 1) {
            <p class="static-text">
              {{ CONGRATS_APPEAL_STATIC_TEXT3 | globalTranslate }}
            </p>
            } @if (appealSummaryInfo.length > 1) {
            <p class="static-text">
              {{ CONGRATS_APPEAL_STATIC_TEXT24 | globalTranslate }}
            </p>
            }
            <p class="static-text">
              {{ CONGRATS_APPEAL_STATIC_TEXT4 | globalTranslate
              }}<strong>{{ appSubmittedDate | date: "MM/dd/yyyy" }}.</strong>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <table class="table w-100 table-striped">
              <thead>
                <tr>
                  <th scope="col" style="text-align: center">
                    {{ Name | globalTranslate }}
                  </th>
                  <th scope="col" style="text-align: center">
                    {{ APPEAL_NUMBER | globalTranslate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (coverage of appealSummaryInfo; track coverage; let i =
                $index) {
                <tr>
                  <td style="text-align: center">{{ coverage.memberName }}</td>
                  <td style="text-align: center">
                    {{ coverage.appealNumber | globalTranslate }}
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
          <div class="col"></div>
        </div>
        <h2 class="section-header">
          {{ CONGRATS_APPEAL_STATIC_TEXT5 | globalTranslate }}
        </h2>
        <hr />
        <p [innerHTML]="CONGRATS_APPEAL_STATIC_TEXT6 | globalTranslate"></p>
        <br />
        <p [innerHTML]="CONGRATS_APPEAL_STATIC_TEXT7 | globalTranslate"></p>
        <br />
        <p [innerHTML]="CONGRATS_APPEAL_STATIC_TEXT8 | globalTranslate"></p>
        <br />
        <p [innerHTML]="CONGRATS_APPEAL_STATIC_TEXT9 | globalTranslate"></p>
        <br />
        <p [innerHTML]="CONGRATS_APPEAL_STATIC_TEXT25 | globalTranslate"></p>
        <p class="appeal_call_info">
          {{ CONGRATS_APPEAL_STATIC_TEXT27 | globalTranslate }}
        </p>
        <br />
        <div>
          <p class="mb-0">{{ "APPEALS_CLERK_HOURS" | globalTranslate }}</p>
          <p class="mb-0">{{ "APPEALS_CLERK_PHONE" | globalTranslate }}</p>
          <p class="mb-0">{{ "APPEALS_CLERK_FAX" | globalTranslate }}</p>
          <p class="mb-0">{{ "APPEALS_CLERK_ADDRESS" | globalTranslate }}</p>
          <p class="mb-0">{{ "APPEALS_CLERK_EMAIL" | globalTranslate }}</p>
        </div>
        <br />
        <h2 class="section-header">
          {{ CONGRATS_APPEAL_STATIC_TEXT12 | globalTranslate }}
        </h2>
        <hr />
        <p>{{ CONGRATS_APPEAL_STATIC_TEXT13 | globalTranslate }}</p>
        <br />
        <p>{{ CONGRATS_APPEAL_STATIC_TEXT14 | globalTranslate }}</p>
        <br />
        <ul class="mb-3 ms-4 print-list">
          <li>{{ CONGRATS_APPEAL_STATIC_TEXT15 | globalTranslate }}</li>
          <li>{{ CONGRATS_APPEAL_STATIC_TEXT16 | globalTranslate }}</li>
          <li>{{ CONGRATS_APPEAL_STATIC_TEXT17 | globalTranslate }}</li>
        </ul>
        <br />
        <p>
          {{ CONGRATS_APPEAL_STATIC_TEXT18 | globalTranslate
          }}<strong>{{
            CONGRATS_APPEAL_STATIC_TEXT19 | globalTranslate
          }}</strong
          >{{ CONGRATS_APPEAL_STATIC_TEXT20 | globalTranslate }}
        </p>
        <div class="appeal_print_pdf">
          <div class="mb-3 mt-4">
            <button
              class="col-md-5 btn btn-secondary-congrats"
              (click)="printAppealPdf()"
              [attr.aria-label]="CONGRATS_APPEAL_STATIC_TEXT21"
            >
              {{ CONGRATS_APPEAL_STATIC_TEXT21 | globalTranslate }}
              <img src="../../assets/images/printw.svg" alt="print-icon" />
            </button>
          </div>
        </div>
        <p>
          {{ CONGRATS_APPEAL_STATIC_TEXT22 | globalTranslate
          }}<a
            href="#"
            (click)="openFaqInNewTab($event)"
            [title]="CONGRATS_APPEAL_STATIC_TEXT23"
            [attr.aria-label]="CONGRATS_APPEAL_STATIC_TEXT23"
            ><strong>{{
              CONGRATS_APPEAL_STATIC_TEXT23 | globalTranslate
            }}</strong></a
          >
        </p>
        <br />
        @if (appealRepresentative === 'Y') {
        <div>
          <h2 class="section-header">
            {{ "APPEAL_SUMMARY_TITLE" | globalTranslate }}
          </h2>
          <hr />
          <p
            class="p_font"
            [innerHtml]="'APPEAL_SUMMARY__DESC1' | globalTranslate | sanitize"
          ></p>
          <br />
          <p
            class="p_font"
            [innerHtml]="
              'APPEAL_CONFIRMATION_POP_DESC2' | globalTranslate | sanitize
            "
          ></p>
          <br />
          <p
            class="p_font"
            [innerHtml]="
              'APPEAL_CONFIRMATION_POP_DESC3' | globalTranslate | sanitize
            "
          ></p>
        </div>
        }
      </section>
    </section>
    @if (!isKepro) {
    <div class="me-3 pr-md-1 py-sm-1 mt-5 mb-2 appeal-exit">
      <button
        id="continue"
        class="btn btn-secondary ms-1"
        (click)="backToMyAppeals()"
        [attr.aria-label]="Exit"
      >
        {{ Exit | globalTranslate }}
      </button>
    </div>
    }
  </div>
  }
</div>
} @if (isMedicalAppeals && !mobileUser && !rmcUpload) {
<div class="medical_appeals_container">
  <section>
    <h1 class="page-title mt-0">
      {{ "CONGRATS_MEDICAL_APPEAL_HEADER" | globalTranslate }}
    </h1>
  </section>
  <section class="border bg-white p-3">
    <section class="p-2">
      <div class="row">
        <div class="col">
          <p class="static-text">
            {{ "CONGRATS_MEDICAL_APPEAL_TEXT_01" | globalTranslate
            }}<strong>{{ appSubmittedDate | date: "MM/dd/yyyy" }}.</strong>
          </p>
          <p class="static-text">
            {{ "CONGRATS_MEDICAL_APPEAL_TEXT_02" | globalTranslate }}
          </p>
          <p
            class="static-text"
            [innerHTML]="'CONGRATS_MEDICAL_APPEAL_TEXT_03' | globalTranslate"
          ></p>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 col-md-6">
          <table class="table w-100 table-striped">
            <thead>
              <tr>
                <th scope="col" style="text-align: center">
                  {{ Name | globalTranslate }}
                </th>
                <th scope="col" style="text-align: center">
                  {{ "ISSUE_NUMBER" | globalTranslate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="text-align: center">
                  {{ medicalAppealSummaryData?.name }}
                </td>
                <td style="text-align: center">
                  {{ medicalAppealSummaryData?.matsIssueId }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col"></div>
      </div>
      <h2 class="section-header">
        {{ CONGRATS_APPEAL_STATIC_TEXT5 | globalTranslate }}
      </h2>
      <hr />
      <p
        class="static-text"
        [innerHTML]="'CONGRATS_MEDICAL_APPEAL_TEXT_04' | globalTranslate"
      ></p>
      @if (medicalAppealSummaryData?.rbaReimburseFlag === 'Y') {
      <div>
        <p class="static-text mt-1">
          {{ "CONGRATS_MEDICAL_APPEAL_01" | globalTranslate }}
        </p>
        <ul class="mb-3 ms-4 print-list">
          <li>{{ "CONGRATS_MEDICAL_APPEAL_02" | globalTranslate }}</li>
          <li>{{ "CONGRATS_MEDICAL_APPEAL_03" | globalTranslate }}</li>
          <li>{{ "CONGRATS_MEDICAL_APPEAL_04" | globalTranslate }}</li>
          <li>{{ "CONGRATS_MEDICAL_APPEAL_05" | globalTranslate }}</li>
          <li>{{ "CONGRATS_MEDICAL_APPEAL_06" | globalTranslate }}</li>
        </ul>
        <p class="static-text">
          {{ "CONGRATS_MEDICAL_APPEAL_07" | globalTranslate }}
        </p>
        <p class="static-text">
          {{ "CONGRATS_MEDICAL_APPEAL_08" | globalTranslate }}
        </p>
        <div>
          <p class="mb-0">
            {{ "CONGRATS_MEDICAL_APPEAL_09" | globalTranslate }}
          </p>
          <p class="mb-0">
            {{ "CONGRATS_MEDICAL_APPEAL_10" | globalTranslate }}
          </p>
          <p class="mb-0">
            {{ "CONGRATS_MEDICAL_APPEAL_11" | globalTranslate }}
          </p>
          <p class="mb-0">
            {{ "CONGRATS_MEDICAL_APPEAL_12" | globalTranslate }}
          </p>
          <p class="mb-0 mt-2">
            {{ "CONGRATS_MEDICAL_APPEAL_13" | globalTranslate }}
          </p>
        </div>
      </div>
      } @if (medicalAppealSummaryData?.rbaBillsFlag === 'Y') {
      <div>
        <p class="static-text mt-1">
          {{ "CONGRATS_MEDICAL_APPEAL_15" | globalTranslate }}
        </p>
        <ul class="mb-3 ms-4 print-list">
          <li>{{ "CONGRATS_MEDICAL_APPEAL_02" | globalTranslate }}</li>
          <li>{{ "CONGRATS_MEDICAL_APPEAL_14" | globalTranslate }}</li>
          <li>{{ "CONGRATS_MEDICAL_APPEAL_04" | globalTranslate }}</li>
          <li>{{ "CONGRATS_MEDICAL_APPEAL_05" | globalTranslate }}</li>
          <li>{{ "CONGRATS_MEDICAL_APPEAL_06" | globalTranslate }}</li>
        </ul>
        <p class="static-text">
          {{ "CONGRATS_MEDICAL_APPEAL_16" | globalTranslate }}
        </p>
        <div>
          <p class="mb-0">
            {{ "CONGRATS_MEDICAL_APPEAL_17" | globalTranslate }}
          </p>
          <p class="mb-0">
            {{ "CONGRATS_MEDICAL_APPEAL_10" | globalTranslate }}
          </p>
          <p class="mb-0">
            {{ "CONGRATS_MEDICAL_APPEAL_11" | globalTranslate }}
          </p>
          <p class="mb-0">
            {{ "CONGRATS_MEDICAL_APPEAL_12" | globalTranslate }}
          </p>
          <p class="mb-0 mt-2">
            {{ "CONGRATS_MEDICAL_APPEAL_18" | globalTranslate }}
          </p>
        </div>
      </div>
      }
      <p
        class="static-text mt-3"
        [innerHTML]="'CONGRATS_MEDICAL_APPEAL_TEXT_07' | globalTranslate"
      ></p>
      <h2 class="section-header">
        {{ "CONGRATS_MEDICAL_APPEAL_PRINT_HEADER" | globalTranslate }}
      </h2>
      <hr />
      <p>{{ "CONGRATS_MEDICAL_APPEAL_TEXT_05" | globalTranslate }}</p>
      <br />
      <p>{{ CONGRATS_APPEAL_STATIC_TEXT14 | globalTranslate }}</p>
      <br />
      <ul class="mb-3 ms-4 print-list">
        <li>{{ CONGRATS_APPEAL_STATIC_TEXT15 | globalTranslate }}</li>
        <li>{{ CONGRATS_APPEAL_STATIC_TEXT16 | globalTranslate }}</li>
        <li>{{ CONGRATS_APPEAL_STATIC_TEXT17 | globalTranslate }}</li>
      </ul>
      <br />
      <p>
        {{ CONGRATS_APPEAL_STATIC_TEXT18 | globalTranslate
        }}<strong>{{ CONGRATS_APPEAL_STATIC_TEXT19 | globalTranslate }}</strong
        >{{ CONGRATS_APPEAL_STATIC_TEXT20 | globalTranslate }}
      </p>
      <div class="appeal_print_pdf">
        <div class="mb-3 mt-4">
          <button
            class="col-md-5 btn btn-secondary-congrats"
            (click)="printMedicalAppealsPdf()"
            [attr.aria-label]="CONGRATS_APPEAL_STATIC_TEXT21"
          >
            {{ CONGRATS_APPEAL_STATIC_TEXT21 | globalTranslate }}
            <img src="../../assets/images/printw.svg" alt="print-icon" />
          </button>
        </div>
      </div>
      <p>
        {{ "CONGRATS_MEDICAL_APPEAL_TEXT_06" | globalTranslate }}
        <a
          class="a-link"
          href="#"
          (click)="openFaqInNewTab($event)"
          [attr.aria-label]="
            'CONGRATS_MEDICAL_APPEAL_TEXT_08' | globalTranslate
          "
          [title]="'CONGRATS_MEDICAL_APPEAL_TEXT_08' | globalTranslate"
          ><strong>{{
            "CONGRATS_MEDICAL_APPEAL_TEXT_08" | globalTranslate
          }}</strong></a
        >
      </p>
    </section>
  </section>
  <div class="me-3 pr-md-1 py-sm-1 mt-5 mb-2 appeal-exit">
    <button
      id="continue"
      class="btn btn-secondary ms-1"
      (click)="backtoMedicalAppeals()"
      [attr.aria-label]="Exit"
    >
      {{ Exit | globalTranslate }}
    </button>
  </div>
</div>
} @if (rmcUpload && !mobileUser) {
<div>
  <section>
    <h1 class="page-title">{{ RMC_DOC_UPLOAD_HEADER | globalTranslate }}</h1>
    <section class="border bg-white p-3">
      <section class="p-2">
        <nh-rmc-uploadDoc
          [rows]="rmcDocUploadRows"
          [wPappNum]="workerPortalAppNum"
        ></nh-rmc-uploadDoc>
      </section>
    </section>
  </section>
  <br />
  @if ((!isAppeals && !isKepro)) {
  <div class="me-3 pr-md-1 py-sm-1">
    <button
      id="continue"
      class="btn btn-secondary ms-1"
      (click)="navigateNext()"
      [attr.aria-label]="CONGRATS_STATIC_TEXT39"
    >
      {{ CONGRATS_STATIC_TEXT39 | globalTranslate }}
    </button>
  </div>
  }
  <br />
  <br />
</div>
} @if (mobileUser && !isRMC) {
<div>
  <section>
    @if (!isPreterm) {
    <h1 class="page-title">
      <span
        >{{ CONGRATS_STATIC_TEXT | globalTranslate }}
        {{ appKeyWord | globalTranslate }}!</span
      >
    </h1>
    } @if (isPreterm) {
    <h1 class="page-title">
      <span
        >{{ CONGRATS_STATIC_TEXT_QFR5 | globalTranslate }}
        {{ appKeyWord | globalTranslate }}!</span
      >
    </h1>
    }
  </section>
  <section class="border bg-white p-3">
    <section class="p-2">
      <div class="row">
        <div class="col">
          @if (!isPreterm) {
          <p class="static-text">
            {{
              isAFB
                ? CONGRATS_STATIC_TEXT_MOBILE_AFB
                : (CONGRATS_STATIC_TEXT1 | globalTranslate)
            }}
            {{ appKeyWord_1 | globalTranslate }}
            {{ CONGRATS_STATIC_TEXT2 | globalTranslate }}
            <strong>{{ workerPortalAppNum }}</strong
            >.
          </p>
          } @if (isPreterm) {
          <p class="static-text">
            {{ CONGRATS_STATIC_TEXT_QFR6 | globalTranslate
            }}{{ appKeyWord | globalTranslate }}
            {{ CONGRATS_STATIC_TEXT_QFR7 | globalTranslate }}
            <strong>{{ workerPortalAppNum }}</strong
            >.
          </p>
          }
          <p class="static-text">
            {{ CONGRATS_STATIC_TEXT3 | globalTranslate }}
          </p>
          @if (isAFB) {
          <p class="static-text">
            {{ CONGRATS_STATIC_TEXT4 | globalTranslate }}
            <strong>{{
              appSubmittedDate | date: "longDate" | globalTranslate
            }}</strong
            >.
          </p>
          } @if (!isAFB) {
          <p class="static-text">
            {{ CONGRATS_STATIC_TEXT4_1 | globalTranslate }}
            <strong>{{
              appSubmittedDate | date: "longDate" | globalTranslate
            }}</strong
            >.
          </p>
          }
        </div>
      </div>
    </section>
    <div class="p-2">
      <div>
        <h2 class="section-header">
          {{ CONGRATS_STATIC_TEXT5 | globalTranslate }}
        </h2>
        <hr />
        @if (rteCaseStatus === 'AP' && idProofScore === 'Y' && isAFB) {
        <p
          class="static-text"
          [innerHTML]="this.CONGRATS_STATIC_TEXT6 | globalTranslate"
        ></p>
        } @if (rteCaseStatus === 'DN' && idProofScore === 'Y' && isAFB) {
        <p
          class="static-text"
          [innerHTML]="
            this.CONGRATS_AFB_MOBILE_REALTIME_TEXT1 | globalTranslate
          "
        ></p>
        } @if (isAFB) {
        <div>
          @if ((rteCaseStatus === 'PE' && idProofScore === 'Y') ||
          !rteCaseStatus) {
          <div class="static-text">
            @if (isAFB) {
            <p
              [innerHTML]="
                this.CONGRATS_AFB_MOBILE_REALTIME_TEXT2 | globalTranslate
              "
            ></p>
            }
          </div>
          }
        </div>
        } @if ((rteCaseStatus === 'AP' || rteCaseStatus === 'DN' ||
        rteCaseStatus === 'APDN' || rteCaseStatus === 'PE') && (idProofScore ===
        'N'|| !idProofScore) && isAFB) {
        <div>
          <p
            class="static-text"
            [innerHTML]="this.CONGRATS_APPEAL_STATIC_TEXT28 | globalTranslate"
          ></p>
          @if (!isNotLinkedAcc) {
          <p
            class="static-text"
            [innerHTML]="
              this.CONGRATS_AFB_MOBILE_REALTIME_TEXT3 | globalTranslate
            "
          ></p>
          }
        </div>
        } @if (rteCaseStatus === 'APDN' && idProofScore === 'Y' && isAFB) {
        <p
          class="static-text"
          [innerHTML]="
            this.CONGRATS_AFB_MOBILE_REALTIME_TEXT4 | globalTranslate
          "
        ></p>
        } @if (rmbRealTimeSwitch && isRmb && !isPreterm) {
        <div>
          @if (rteCaseStatus === 'AP') {
          <p
            class="static-text"
            [innerHTML]="this.CONGRATS_RMB_REALTIME_TEXT1 | globalTranslate"
          ></p>
          } @if (rteCaseStatus === 'TN') {
          <p
            class="static-text"
            [innerHTML]="this.CONGRATS_RMB_REALTIME_TEXT2 | globalTranslate"
          ></p>
          } @if (rteCaseStatus === 'PE') {
          <p
            class="static-text"
            [innerHTML]="
              this.CONGRATS_RMB_MOBILE_REALTIME_TEXT1 | globalTranslate
            "
          ></p>
          }
          <!-- If status includes 'PE' but is not only 'PE', e.g., 'APPE', 'PEDN'  -->
          <!-- If status does NOT include 'PE' and is status (length > 2), e.g., 'APDN', 'TNDN', 'APTNDN' -->
          @if (((rteCaseStatus !== 'PE' && rteCaseStatus?.includes('PE')) ||
          (!rteCaseStatus?.includes('PE') && rteCaseStatus?.length > 2))) {
          <p
            class="static-text"
            [innerHTML]="
              this.CONGRATS_RMB_MOBILE_REALTIME_TEXT2 | globalTranslate
            "
          ></p>
          } @if (!rteCaseStatus) {
          <p
            class="static-text"
            [innerHTML]="
              this.CONGRATS_RMB_MOBILE_REALTIME_TEXT3 | globalTranslate
            "
          ></p>
          }
        </div>
        } @if (!rmbRealTimeSwitch && !isAFB) {
        <p [innerHTML]="CONGRATS_STATIC_TEXT6_app | globalTranslate"></p>
        }
      </div>
    </div>
    @if (!isAFB) {
    <div>
      <h2 class="section-header">
        {{ COMM_PREF_FINISHMODULE_BANNER_TEXT1 | globalTranslate }}
      </h2>
      <hr />
      <p [innerHTML]="MOBILE_APP_STATIC1 | globalTranslate"></p>
    </div>
    }
    <div>
      <h2 class="section-header">
        {{
          isAFB
            ? MOBILE_AFB_CHANGE_LETTERS
            : (CHANGE_HOW_LETTERS | globalTranslate)
        }}
      </h2>
      <hr />
      @if (!isAFB) {
      <p [innerHTML]="MOBILE_APP_STATIC2 | globalTranslate"></p>
      } @if (isAFB) {
      <p [innerHTML]="CONGRATS_AFB_MOBILE_TEXT5 | globalTranslate"></p>
      }
    </div>
    @if (kbDataList?.length > 0 && kbDataList[0]?.kbReferralId !== null) {
    <div>
      <h2 class="section-header">
        {{ CONGRATS_STATIC_TEXT10 | globalTranslate }}
      </h2>
      <hr />
      <p>
        {{
          isAFB
            ? CONGRATS_STATIC_TEXT11
            : (CONGRATS_STATIC_TEXT11_1 | globalTranslate)
        }}
      </p>
      @for (ref of kbDataList; track ref) {
      <p>
        {{ CONGRATS_STATIC_TEXT12 | globalTranslate }}
        {{ ref.name | globalTranslate }}
        {{ CONGRATS_STATIC_TEXT13 | globalTranslate }}
        <strong>{{ ref.kbReferralId }}.</strong><br />{{
          isAFB
            ? CONGRATS_STATIC_TEXT14
            : (CONGRATS_STATIC_TEXT14_1 | globalTranslate)
        }}
      </p>
      }
      <p>
        {{
          isAFB
            ? CONGRATS_STATIC_TEXT15
            : (CONGRATS_STATIC_TEXT15_1 | globalTranslate)
        }}
        @for (ref of kbDataList; track ref; let isLast = $last) {
        <span
          >{{ ref.name | globalTranslate
          }}{{ isLast ? "" : ("or " | globalTranslate) }}</span
        >
        }
        {{
          isAFB
            ? CONGRATS_STATIC_TEXT16
            : (CONGRATS_STATIC_TEXT16_1 | globalTranslate)
        }}
        <!-- <p [innerHTML]="this.CONGRATS_STATIC_TEXT17_1"></p> -->
      </p>

      <p class="m-0">
        {{
          isAFB
            ? CONGRATS_STATIC_TEXT18
            : (CONGRATS_STATIC_TEXT18_1 | globalTranslate)
        }}
      </p>
      <ul>
        <li>
          <strong>{{ CONGRATS_STATIC_TEXT19 | globalTranslate }}: </strong>
          901-745-7200 or 800-308-2586
        </li>
        <li>
          <strong>{{ CONGRATS_STATIC_TEXT20_1 | globalTranslate }}: </strong>
          615-231-5047
        </li>
        <li>
          <strong>{{ CONGRATS_STATIC_TEXT21 | globalTranslate }}: </strong>
          865-588-0508
        </li>
        <br />
      </ul>
    </div>
    } @if (ecfIndicator === 'Y') {
    <div class="mt-4">
      <h2 class="section-header">
        {{ CONGRATS_STATIC_TEXT22 | globalTranslate }}
      </h2>
      <hr />
      <p>{{ CONGRATS_STATIC_TEXT23 | globalTranslate }}</p>
      <p>
        {{ CONGRATS_STATIC_TEXT24 | globalTranslate
        }}<a
          class="a-link"
          href="https://perlss.tenncare.tn.gov/externalreferral"
          ><b>{{ CONGRATS_STATIC_TEXT25 | globalTranslate }}</b></a
        >. {{ CONGRATS_STATIC_TEXT26 | globalTranslate }}
      </p>
      <p class="m-0">{{ CONGRATS_STATIC_TEXT27 | globalTranslate }}</p>
      <ul>
        <li>
          <span class="pe-5"
            >{{ CONGRATS_STATIC_TEXT19 | globalTranslate }} Tennessee</span
          ><span class="pl-3">866-372-5709</span>
        </li>
        <li>
          <span class="pe-5"
            >{{ CONGRATS_STATIC_TEXT20 | globalTranslate }} Tennessee</span
          >800-654-4839
        </li>
        <li>
          <span class="pe-5"
            >{{ CONGRATS_STATIC_TEXT21 | globalTranslate }} Tennessee</span
          ><span class="pl-4">888-531-9876</span>
        </li>
        <br />
      </ul>
    </div>
    }
    <div>
      <h2 class="section-header">
        {{
          isAFB
            ? MOBILE_AFB_STATIC_TEXT1
            : (MOBILE_APP_STATIC3 | globalTranslate)
        }}
      </h2>
      <hr />
      @if (!isAFB) {
      <p [innerHTML]="MOBILE_APP_STATIC4 | globalTranslate"></p>
      } @if (isAFB) {
      <p [innerHTML]="MOBILE_AFB_STATIC_TEXT2 | globalTranslate"></p>
      }
    </div>
  </section>
  <br />
</div>
}

<!-- rmc mobile app -->
@if (mobileUser && isRMC) {
<div>
  <section>
    <h1 class="page-title">
      <span>{{ CONGRATS_STATIC_MOBILE_RMC_TEXT | globalTranslate }}</span>
    </h1>
  </section>
  <section class="border bg-white p-3">
    <section class="p-2">
      <div class="row">
        <div class="col">
          <p class="static-text">
            {{ CONGRATS_STATIC_TEXT1 | globalTranslate }}
            {{ appKeyWord_1 | globalTranslate }}
            {{ CONGRATS_STATIC_TEXT2 | globalTranslate }}
            <strong>{{ workerPortalAppNum }}</strong
            >.
          </p>
          <p class="static-text">
            {{ CONGRATS_STATIC_TEXT3 | globalTranslate }}
          </p>
          <p class="static-text">
            {{ CONGRATS_CHAGE_MODE | globalTranslate }}
            <strong>{{
              appSubmittedDate | date: "longDate" | globalTranslate
            }}</strong
            >.
          </p>
        </div>
      </div>
    </section>
    <div>
      <h2 class="section-header">
        {{ CONGRATS_STATIC_MOBILE_RMC_TEXT5 | globalTranslate }}
      </h2>
      <hr />
      @if (rteCaseStatus === 'AP') {
      <p
        class="static-text"
        [innerHTML]="this.CONGRATS_STATIC_TEXT6 | globalTranslate"
      ></p>
      } @if (rteCaseStatus === 'DN') {
      <p
        class="static-text"
        [innerHTML]="this.CONGRATS_STATIC_TEXT7 | globalTranslate"
      ></p>
      } @if (rteCaseStatus === 'PE' || !rteCaseStatus) {
      <div class="static-text">
        @if (realTimeAppMessage !== 'RT_RMC_SUC') {
        <p
          [innerHTML]="
            this.CONGRATS_STATIC_TEXT_MOBILE_RMC_NOT_REAL_TIME8
              | globalTranslate
          "
        ></p>
        }
      </div>
      } @if (rteCaseStatus === 'RT') {
      <div class="static-text">
        @if (realTimeAppMessage !== 'RT_RMC_SUC') {
        <p
          [innerHTML]="
            this.CONGRATS_STATIC_TEXT_MOBILE_RMC_NOT_REAL_TIME8
              | globalTranslate
          "
        ></p>
        }
      </div>
      } @if (rteCaseStatus === 'RS') {
      <div class="static-text">
        @if (realTimeAppMessage === 'RT_RMC_SUC') {
        <p
          [innerHTML]="
            this.CONGRATS_STATIC_TEXT_MOBILE_RMC_REAL_TIME8 | globalTranslate
          "
        ></p>
        }
      </div>
      } @if (rteCaseStatus === 'APDN') {
      <p
        class="static-text"
        [innerHTML]="this.CONGRATS_STATIC_TEXT9 | globalTranslate"
      ></p>
      }
    </div>
    <div>
      <h2 class="section-header">
        {{ MOBILE_AFB_CHANGE_LETTERS | globalTranslate }}
      </h2>
      <hr />
      <p [innerHTML]="CONGRATS_RMC_MOBILE_TEXT5 | globalTranslate"></p>
    </div>
    <div>
      <h2 class="section-header">
        {{ MOBILE_RMC_STATIC_TEXT1 | globalTranslate }}
      </h2>
      <hr />
      <p [innerHTML]="MOBILE_RMC_STATIC_TEXT2 | globalTranslate"></p>
    </div>
  </section>
  <br />
</div>
}
